"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var ModalHelpComponent = (function () {
    function ModalHelpComponent(elementRef, eventService, localizationService) {
        this.elementRef = elementRef;
        this.eventService = eventService;
        this.localizationService = localizationService;
    }
    ModalHelpComponent.prototype.ngOnInit = function () {
        this.renderLocals();
        this.subscribeOnEvents();
    };
    ModalHelpComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalHelpComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideModalsEvent =
            this.eventService.subscribe('hideModals', function () { return _this.hideModalHelp(); });
        this.subscriptionShowModalHelpEvent =
            this.eventService.subscribe('showModalHelp', function (stateDarkModalHelp) { return _this.showModalHelp(stateDarkModalHelp); });
        this.subscriptionChangeLocalsEvent =
            this.eventService.subscribe('changeLocals', function () { return _this.renderLocals(); });
    };
    ModalHelpComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalsEvent.unsubscribe();
        this.subscriptionShowModalHelpEvent.unsubscribe();
        this.subscriptionChangeLocalsEvent.unsubscribe();
    };
    ModalHelpComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
        });
    };
    ModalHelpComponent.prototype.renderToolsInfos = function () {
        var _this = this;
        this.localizationService.toolsLocals
            .then(function (tools) {
            _this.toolsLocals = tools;
        });
    };
    ModalHelpComponent.prototype.renderHotKeysLocals = function () {
        var _this = this;
        this.localizationService.hotKeysLocals
            .then(function (hotKeys) {
            _this.hotKeysLocals = hotKeys;
        });
    };
    ModalHelpComponent.prototype.renderLocals = function () {
        this.renderInterfaceLocals();
        this.renderToolsInfos();
        this.renderHotKeysLocals();
    };
    ModalHelpComponent.prototype.detectForModalEnd = function (event) {
        var target = event.target;
        this.changeScrollStateToBottom(target);
        this.changeScrollStateToTop(target);
    };
    ModalHelpComponent.prototype.isScrollBottom = function (target) {
        return target.scrollHeight - target.clientHeight === target.scrollTop;
    };
    ModalHelpComponent.prototype.isScrollTop = function (target) {
        return target.scrollTop === 0;
    };
    ModalHelpComponent.prototype.changeScrollStateToBottom = function (target) {
        if (this.isScrollBottom(target)) {
            this.focusHelpWindow();
            this.stateBottomScroll = true;
        }
    };
    ModalHelpComponent.prototype.changeScrollStateToTop = function (target) {
        if (this.isScrollTop(target)) {
            this.stateBottomScroll = false;
        }
    };
    ModalHelpComponent.prototype.hideModalHelp = function () {
        this.stateActiveModalHelp = false;
        this.stateDarkModalHelp = false;
        this.pureScrollTop();
    };
    ModalHelpComponent.prototype.showModalHelp = function (stateDarkModalHelp) {
        var _this = this;
        this.helpWindow = this.elementRef.nativeElement.querySelector('.js-help-window');
        this.modalHelp = this.elementRef.nativeElement.querySelector('.js-modal-help');
        this.modalHelp.addEventListener('transitionend', function () { return _this.focusHelpWindow(); });
        this.modalHelp.addEventListener('click', function () { return _this.focusHelpWindow(); });
        if (stateDarkModalHelp) {
            this.stateDarkModalHelp = true;
        }
        this.stateActiveModalHelp = true;
    };
    ModalHelpComponent.prototype.focusHelpWindow = function () {
        this.helpWindow.focus();
    };
    ModalHelpComponent.prototype.scrollDown = function () {
        var _this = this;
        this.animateScroll(function (helpWindow, step) {
            if (_this.isScrollBottom(helpWindow)) {
                return true;
            }
            helpWindow.scrollTop += step;
        });
    };
    ModalHelpComponent.prototype.pureScrollTop = function () {
        this.stop = true;
        if (this.helpWindow) {
            this.helpWindow.scrollTop = 0;
            this.changeScrollStateToTop(this.helpWindow);
        }
    };
    ModalHelpComponent.prototype.animateScroll = function (callback) {
        var _this = this;
        var step = 0;
        this.stop = false;
        var animate = function () {
            step++;
            var stop = _this.stop || callback(_this.helpWindow, step);
            if (stop) {
                return;
            }
            requestAnimationFrame(animate);
        };
        animate();
    };
    return ModalHelpComponent;
}());
ModalHelpComponent = __decorate([
    core_1.Component({
        selector: 'modal-help-component',
        template: require('./modal-help.component.pug'),
        styles: [require('./modal-help.component.scss')]
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        services_1.EventService,
        services_1.LocalizationService])
], ModalHelpComponent);
exports.ModalHelpComponent = ModalHelpComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/modal-help/modal-help.component.ts
// module id = 248
// module chunks = 0